import { isDefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import stringify from 'fast-json-stable-stringify';

import { DetailFeatures, FEATURES } from '../../constants.ts';
import { selectAllImprovements } from './propertyDataSelectors/improvementsSelectors.ts';

/** @deprecated: Use `orderSelectors#selectOrderFeatures` instead. */
export const selectOrderFeatures = createSelector(
  [selectAllImprovements],
  (improvements) => {
    const features = new Set<DetailFeatures>();
    improvements.forEach((improvement) => {
      Object.entries(FEATURES).forEach(([feature, { hasFeature, getDetails }]) => {
        if (hasFeature(improvement) && isDefined(getDetails)) {
          features.add(feature as DetailFeatures);
        }
      });
    });
    return Array.from(features);
  },
  {
    memoizeOptions: {
      resultEqualityCheck: (prev: DetailFeatures[], curr: DetailFeatures[]) =>
        stringify(prev) === stringify(curr),
    },
  },
);
